import React from 'react';
import { AlertTriangle, ClipboardX } from 'lucide-react';
import { useScopeOverdueSummary } from '../../../hooks/analytics/useScopeReports.ts';
import { StatCard, WidgetCard } from '../controller/shared.tsx';

/**
 * `scope_overdue` — testing + PBC overdue KPI pair. The endpoint also returns
 * the overdue rows (capped 50, most-overdue first); this tile stays a compact
 * two-number summary, consistent with the other `kpi`-category scope widgets.
 */
export const ScopeOverdueCard: React.FC = () => {
  const { data, isLoading, isError, error, dataUpdatedAt, isFetching, refetch } = useScopeOverdueSummary();

  return (
    <WidgetCard
      title="Overdue Testing & PBC"
      description="Past-due test runs and evidence requests"
      loading={isLoading}
      error={isError ? error : null}
      errorMessage={error?.message ?? 'Failed to load overdue summary.'}
      isEmpty={!isLoading && !isError && !data}
      updatedAt={dataUpdatedAt}
      onRefresh={refetch}
      isFetching={isFetching}
    >
      <div className="analytics-kpi-grid gap-3">
        <StatCard
          title="Testing Overdue"
          value={data?.testing_overdue ?? 0}
          icon={<AlertTriangle className="h-5 w-5" />}
          color="bg-rose-100 text-rose-600"
        />
        {/* Urgency-color fix (feedback round 2026-08-23): overdue is always red, never amber. */}
        <StatCard
          title="PBC Overdue"
          value={data?.pbc_overdue ?? 0}
          icon={<ClipboardX className="h-5 w-5" />}
          color="bg-rose-100 text-rose-600"
        />
      </div>
    </WidgetCard>
  );
};

export default ScopeOverdueCard;
